import { Injectable, Injector } from '@angular/core';
import { BidNotesPool } from '@authority-labs/api-interfaces';
import { CrudService } from './crud/crud.service';

@Injectable({
  providedIn: 'root'
})
export class BidNotesPoolService extends CrudService<BidNotesPool> {
  constructor(injector: Injector) {
    super(injector, 'bid-notes-pool', BidNotesPool);
  }
}
